import React from "react";

import {
    Platform,
    View,
    Text,
    ViewStyle,
    Image,
    TextStyle
} from "react-native";
import AppTheme from "../../../utils/Theme";
import Divider from "../../../designSystem/Divider/Divider";
import Button from "../../../designSystem/Button";

interface PremiumCellProps {
    id: string;
    header?: number;
    title?: string;
    body?: string;
    number_of_cell: number;
    gap: number;
    full_header?: boolean;
    backgroundColor?: string;
    textColor?: string;
    title_font?: string;
    title_uppercase?: boolean;
    button?: { title: string; action: () => void };
    extraComponent?: React.JSX.Element[];
    flexDirection: "row" | "column";
    screenWidth: number;
    leftView?: React.JSX.Element[];
    rightView?: React.JSX.Element[];
}

const PremiumCell = (props: PremiumCellProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { leftView, rightView, id, header, title, body, button, extraComponent = null, number_of_cell, gap, backgroundColor = "#FFFFFF", textColor = appTheme.darkBlue, full_header = true, title_font = appTheme.superHerosFontBold, title_uppercase = true, flexDirection, screenWidth } = props;
    const cellWidth: number = flexDirection === "column" ? screenWidth : (screenWidth * ((1 - ((number_of_cell - 1) * gap))) / number_of_cell);

    const whiteBoxStyle: ViewStyle = {
        width: screenWidth,
        paddingHorizontal: appTheme.pixelPerfect(10),
        paddingVertical: appTheme.pixelPerfect(10),
        flexDirection: appTheme.getFlexDirectionForSplitScreen(),
        backgroundColor: "#FFFFFF",
        borderRadius: appTheme.pixelPerfect(30),
        overflow: "hidden"
    }

    const sectionTitleStyle: TextStyle = {
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(15) : appTheme.pixelPerfectForFont(12),
        color: appTheme.darkBlue,
        textAlign: "center",
        paddingHorizontal: 10
    }

    const sectionBodyStyle: TextStyle = {
        fontFamily: appTheme.primarySemiBoldFont,
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(9),
        color: appTheme.darkBlue,
        paddingHorizontal: appTheme.pixelPerfect(20),
        textAlign: "center"
    }

    const headerImage: React.JSX.Element[] | null = header === undefined ? null : [
        <Image resizeMode={full_header === true ? "cover" : "contain"} source={header} style={{ width: full_header === true ? cellWidth : Platform.OS === "web" ? cellWidth - appTheme.pixelPerfect(120) : cellWidth - appTheme.pixelPerfect(60), height: Platform.OS === "web" ? appTheme.pixelPerfect(120) : appTheme.pixelPerfect(80) }} />,
        <Divider />];

    const bodySection: React.JSX.Element[] | null = body === undefined ? null : [
        <Text style={[sectionBodyStyle, { color: textColor, fontFamily: appTheme.primaryMediumFont }]}>{body}</Text>,
        <Divider />];

    let leftContainer: React.JSX.Element | null = null;
    if (leftView !== undefined) {
        leftContainer = <View style={{ margin: appTheme.pixelPerfect(20) }}>
            {leftView}
        </View>;
    }

    let rightContainer: React.JSX.Element | null = null;
    if (rightView !== undefined) {
        rightContainer = <View style={{ margin: appTheme.pixelPerfect(10) }}>
            {rightView}
        </View>;
    }

    let buttonView: React.JSX.Element | null = null;
    if (button !== undefined) {
        buttonView = <View style={{ width: Platform.OS === "web" ? "auto" : cellWidth, paddingHorizontal: appTheme.pixelPerfect(10), justifyContent: "flex-end" }}>
            <Button title={button.title} onPress={button.action} textStyle={{ paddingHorizontal: appTheme.pixelPerfect(20), color: appTheme.darkBlue, fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(7) : appTheme.pixelPerfectForFont(8) }} style={{ minHeight: appTheme.pixelPerfect(36), paddingVertical: appTheme.pixelPerfect(4), backgroundColor: "#FFD77A" }} />
        </View>
    }

    const renderTitle = (): React.JSX.Element[] | null => {
        if ((title === undefined) && (rightView === undefined) && (leftView === undefined)) {
            return null;
        }
        console.log("HE", {title, rightView, leftView})
        let titleView: React.JSX.Element | null = title === undefined ? null : <Text style={[sectionTitleStyle, { textAlign: rightView !== undefined ? "right" : leftView !== undefined ? "left" : "center", flexShrink: 1, paddingHorizontal: appTheme.pixelPerfect(4), color: textColor, fontFamily: title_font, fontSize: appTheme.pixelPerfectForFont(10), textTransform: title_uppercase === true ? "uppercase" : "none" }]}>{title}</Text>;
        return [
            <View style={{ width: cellWidth, flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                {leftContainer}
                {titleView}
                {rightContainer}
            </View>,
            <Divider />
        ]
    }

    return <View key={id} style={[whiteBoxStyle, { backgroundColor, paddingHorizontal: 0, width: cellWidth, paddingVertical: full_header === true ? 0 : flexDirection === "column" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(20), paddingBottom: appTheme.pixelPerfect(20), marginVertical: appTheme.pixelPerfect(10) }]}>
        <View style={{ flex: 1, alignItems: "center", justifyContent: full_header === true ? "flex-start" : "center" }}>
            {headerImage}
            {renderTitle()}
            {bodySection}
            {extraComponent !== undefined ? [extraComponent, <Divider />] : null}
            {buttonView}
        </View>
    </View>
}

export default PremiumCell;